/**
 * Get value from localStorage
 * @param {string} key - The key to retrieve
 * @param {*} fallback - Value to return if key doesn't exist or on error
 * @param {boolean} [parseJSON=false] - If true, parses value as JSON
 * @returns {*} Value or fallback
 */
const getLS = (key, fallback = null, parseJSON = false) => {
	if (!key || typeof key !== 'string') return fallback;

	try {
		const value = localStorage.getItem(key);
		if (value === null) return fallback;
		return parseJSON ? JSON.parse(value) : value;
	} catch {
		return fallback;
	}
};

/**
 * Set value in localStorage
 * @param {string} key - The key to set
 * @param {*} val - The value to store
 * @param {boolean} [useJSON=false] - If true, stringifies value as JSON
 * @returns {boolean} - Success status
 */
const setLS = (key, val, useJSON = false) => {
	if (!key || typeof key !== 'string') return false;

	try {
		localStorage.setItem(key, useJSON ? JSON.stringify(val) : val);
		return true;
	} catch {
		return false;
	}
};

/**
 * Remove item from localStorage
 * @param {string} key - The key to remove
 * @returns {boolean} - Success status
 */
const removeLS = (key) => {
	if (!key || typeof key !== 'string') return false;

	try {
		localStorage.removeItem(key);
		return true;
	} catch {
		return false;
	}
};

export { getLS, setLS, removeLS };